import jwt_decode from 'jwt-decode';

class Token {

    validate(token) {
        try {
            if(!token) return false;
            const decode = jwt_decode(token);

            if(decode.iss.indexOf('wrightbalance') < 0) {
                return false;
            }
            
            return true;

        } catch(err) {
            return false;
        }
    }
}

export default new Token();


// WEBPACK FOOTER //
// ./src/Token.js